import { render, staticRenderFns } from "./CreateLevels.vue?vue&type=template&id=5cc63988&scoped=true"
import script from "./CreateLevels.vue?vue&type=script&lang=js"
export * from "./CreateLevels.vue?vue&type=script&lang=js"
import style0 from "./CreateLevels.vue?vue&type=style&index=0&id=5cc63988&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc63988",
  null
  
)

export default component.exports